// extracted by mini-css-extract-plugin
module.exports = {"content":"FacebookAlertEvent_content__1Ll1b","fullWidth":"FacebookAlertEvent_fullWidth__21Rfg","compact":"FacebookAlertEvent_compact__2ALDx"};